import React from 'react';
import {
  ConfettiContainer,
  ConfettiElement1,
  ConfettiElement2,
  ConfettiElement3,
  ConfettiElement4,
  ConfettiElement5,
} from './banner.courses.confetti.styles';

const BannerCoursesConfetti = (): JSX.Element => {
  return (
    <ConfettiContainer>
      <ConfettiElement1 />
      <ConfettiElement2 />
      <ConfettiElement3 />
      <ConfettiElement4 />
      <ConfettiElement5 />
    </ConfettiContainer>
  );
};

export default BannerCoursesConfetti;
